module.exports = __webpack_public_path__ + "assets/img/Newsletter.a3c4f230.jpg";